module.exports = __webpack_public_path__ + "img/home_gs_icon.9e470a5.png";